import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";
import { Switch } from "../ui/switch";

export default function EditPricing({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setPlan = (i, key, v) => {
    const plans = [...(value.plans || [])];
    plans[i] = { ...plans[i], [key]: v };
    set("plans", plans);
  };
  const setFeature = (i, fi, v) => {
    const plans = [...(value.plans || [])];
    const feats = [...(plans[i].features || [])];
    feats[fi] = v;
    plans[i] = { ...plans[i], features: feats };
    set("plans", plans);
  };
  const addFeature = (i) => {
    const plans = [...(value.plans || [])];
    plans[i] = { ...plans[i], features: [...(plans[i].features || []), "Novo benefício"] };
    set("plans", plans);
  };
  const removeFeature = (i, fi) => {
    const plans = [...(value.plans || [])];
    plans[i] = { ...plans[i], features: (plans[i].features || []).filter((_, idx) => idx !== fi) };
    set("plans", plans);
  };
  const addPlan = () => set("plans", [...(value.plans || []), { name: "Novo Plano", price: "R$ 0", period: "/mês", features: [], ctaLabel: "Quero Esse Plano", ctaUrl: "" }]);
  const removePlan = (i) => set("plans", (value.plans || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Investimento (Planos)">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="pricing-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="pricing-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="pricing-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Planos</span>
            <ListAddBtn onClick={addPlan} label="Adicionar plano" testId="pricing-add-plan" />
          </div>
          <div className="space-y-5">
            {(value.plans || []).map((p, i) => (
              <div key={i} data-testid={`pricing-row-${i}`} className="border border-border p-4 space-y-3 relative">
                <div className="absolute top-3 right-3"><ListRemoveBtn onClick={() => removePlan(i)} testId={`pricing-remove-${i}`} /></div>
                <div className="grid sm:grid-cols-3 gap-3">
                  <Field label="Nome do plano"><TextInput value={p.name} onChange={(v) => setPlan(i, "name", v)} testId={`pricing-name-${i}`} /></Field>
                  <Field label="Selo (ex: MAIS VENDIDO)"><TextInput value={p.badge} onChange={(v) => setPlan(i, "badge", v)} testId={`pricing-badge-${i}`} /></Field>
                  <label className="flex items-center gap-3 text-sm pt-6">
                    <Switch
                      data-testid={`pricing-highlighted-${i}`}
                      checked={!!p.highlighted}
                      onCheckedChange={(c) => setPlan(i, "highlighted", c)}
                    />
                    Destacar
                  </label>
                </div>
                <div className="bg-alabaster border border-border p-3 space-y-3">
                  <p className="text-xs tracking-[0.2em] uppercase text-gold flex items-center gap-2">
                    <span>🇧🇷</span> Preço Brasil (BRL)
                  </p>
                  <div className="grid sm:grid-cols-3 gap-3">
                    <Field label="Preço (R$)"><TextInput value={p.price} onChange={(v) => setPlan(i, "price", v)} testId={`pricing-price-${i}`} /></Field>
                    <Field label="Período (ex: /mês)"><TextInput value={p.period} onChange={(v) => setPlan(i, "period", v)} testId={`pricing-period-${i}`} /></Field>
                    <Field label="Preço original (riscado)"><TextInput value={p.originalPrice} onChange={(v) => setPlan(i, "originalPrice", v)} testId={`pricing-original-${i}`} /></Field>
                  </div>
                </div>
                <div className="bg-alabaster border border-border p-3 space-y-3">
                  <p className="text-xs tracking-[0.2em] uppercase text-gold flex items-center gap-2">
                    <span>🇪🇺</span> Preço Europa (EUR)
                  </p>
                  <div className="grid sm:grid-cols-3 gap-3">
                    <Field label="Preço (€)"><TextInput value={p.priceEU} onChange={(v) => setPlan(i, "priceEU", v)} testId={`pricing-price-eu-${i}`} /></Field>
                    <Field label="Período"><TextInput value={p.periodEU} onChange={(v) => setPlan(i, "periodEU", v)} testId={`pricing-period-eu-${i}`} /></Field>
                    <Field label="Preço original (riscado)"><TextInput value={p.originalPriceEU} onChange={(v) => setPlan(i, "originalPriceEU", v)} testId={`pricing-original-eu-${i}`} /></Field>
                  </div>
                  <p className="text-[10px] text-onyx/40">Deixe em branco para usar o preço em R$ também para visitantes da Europa.</p>
                </div>
                <Field label="Descrição"><TextArea value={p.description} onChange={(v) => setPlan(i, "description", v)} rows={2} testId={`pricing-description-${i}`} /></Field>
                <div className="grid sm:grid-cols-2 gap-3">
                  <Field label="Texto do botão"><TextInput value={p.ctaLabel} onChange={(v) => setPlan(i, "ctaLabel", v)} testId={`pricing-cta-label-${i}`} /></Field>
                  <Field label="URL do botão (deixe vazio para usar URL global)"><TextInput value={p.ctaUrl} onChange={(v) => setPlan(i, "ctaUrl", v)} testId={`pricing-cta-url-${i}`} /></Field>
                </div>
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Benefícios do plano</span>
                    <button type="button" onClick={() => addFeature(i)} data-testid={`pricing-add-feature-${i}`} className="text-xs underline">+ benefício</button>
                  </div>
                  <div className="space-y-2">
                    {(p.features || []).map((f, fi) => (
                      <div key={fi} className="flex gap-2 items-center">
                        <div className="flex-1"><TextInput value={f} onChange={(v) => setFeature(i, fi, v)} testId={`pricing-feature-${i}-${fi}`} /></div>
                        <ListRemoveBtn onClick={() => removeFeature(i, fi)} testId={`pricing-feature-remove-${i}-${fi}`} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
